export const USDT_ADDRESS = "0x983E478F15bd1848B5B9014771DEdd049bBa5Df4";
export const CHAIN_ID = 5;
export const CAMPAIGN_ADDRESS = "0xDa3ea2222f2cF23BA3bb2063F8E7a5Edb1762694";

export enum IDOStage {
  ROUND_1 = 1,
  ROUND_1_END,
  ROUND_2,
  ROUND_2_END,
}

export const IDO_STAGE = parseInt(
  process.env.NEXT_PUBLIC_IDO_STAGE as string
) as IDOStage;

export function getCurrentRound(stage: IDOStage) {
  switch (stage) {
    case IDOStage.ROUND_1:
      return 1;
    case IDOStage.ROUND_1_END:
      return 1;
    case IDOStage.ROUND_2:
      return 2;
    case IDOStage.ROUND_2_END:
      return 2;
    default:
      return 1;
  }
}

export const currentRound = getCurrentRound(IDO_STAGE);
